export let PREMIUM_PLANS = /*#__PURE__*/function (PREMIUM_PLANS) {
  PREMIUM_PLANS["NONE"] = "";
  PREMIUM_PLANS["BASIC"] = "Connect Domain + Wix Video";
  PREMIUM_PLANS["COMBO"] = "Combo + Wix Video";
  PREMIUM_PLANS["PRO"] = "Unlimited + Wix Video";
  PREMIUM_PLANS["VIP"] = "VIP + Wix Video";
  PREMIUM_PLANS["VIDEO_VIP"] = "video_vip";
  PREMIUM_PLANS["VIDEO_EXTENSIVE"] = "video_extensive";
  PREMIUM_PLANS["VIDEO_BUSINESS"] = "video_business";
  PREMIUM_PLANS["VIDEO_BASIC"] = "video_basic";
  PREMIUM_PLANS["VIDEO_MINIMAL"] = "video_minimal";
  PREMIUM_PLANS["VIDEO_COMPACT"] = "video_compact";
  PREMIUM_PLANS["FREE"] = "Free";
  PREMIUM_PLANS["PREMIUM"] = "Premium";
  return PREMIUM_PLANS;
}({});
//# sourceMappingURL=premium-plans.js.map